<template>

  <div ref="flipCard" class="relative span-14-md offset-1-md span-14-sm offset-1-sm span-14-xs offset-1-xs share-flip-outer no-border content-translate" v-bind:class="[cardSizeClass, contentActiveClass]" :style="ratio_styles">

    <div class="flip-container">

      <div class="flipper crosshair-rollover-trigger" v-on:click="flip">

        <!-- front outer -->
        <div class="front ind-2 border-blue-hover center-flex" front-card :class="flipped">
          
          <!-- inner front content -->
          <div class="front-inner">

            <div v-if="icon" class="svg-icon-background big-svg"><component :is="icon"></component></div>
            <!-- upcase -->
            <div class="subheader ">{{title}}</div>

          </div>

        </div>

        <!-- back outer -->
        <div class="back border-blue-hover" :class="flipped">

          <div class="scroll-outer maintain-outer" ref="scrollHookOne">

            <!-- inner back content -->
            <div class="back-inner">
              <!-- upcase -->
              <div class="subheader "> 
                <div v-if="icon" class="svg-icon-background svg-icon-background-small"><component :is="icon"></component></div> <span>{{title}}</span>
              </div>

              <p><slot></slot></p>

            </div>

          </div>

        </div>

        

      </div>

      <crosshair-background v-if="cardSize < 4"></crosshair-background>
      

    </div>

  </div>
</template>

<script>
  import crosshair_background from '../atoms/crosshair_background'
  import svg from '../svg'

  import {ratio_height, ratio_styles} from '../../utils/ratio_height'
  import PerfectScrollbar from 'perfect-scrollbar';

  export default {
    props: ['title', 'icon', 'cardSize', 'ind', 'active'],
    components: {
      'crosshair-background': crosshair_background,
      ...svg
    },
    data () {
      return {
        ratio_styles,
        flipped: null,
        contentActiveClass: 'content-inactive',
        psOne: null
      }
    },
    methods: {
      get_ratio (w) {
        if (w.innerWidth < 1200) {
          return 2/3
        }
        return 5/4
      },
      flip () {
        if(!this.flipped) {
          this.flipped = 'flipped'
          this.$emit('flip', 1)
          setTimeout(() => {
            this.psOne.update()
          }, 600)
        } else {
          this.flipped = null
          this.$emit('flip', -1)
        }
      },
      ratioInit () {
        ratio_height(this, this.$refs.flipCard, this.get_ratio(window))
        window.addEventListener('resize', () => {
          setTimeout(() => {
            ratio_height(this, this.$refs.flipCard, this.get_ratio(window))
          }, 500)
          setTimeout(() => {
            ratio_height(this, this.$refs.flipCard, this.get_ratio(window))
          }, 1000)
          setTimeout(() => {
            ratio_height(this, this.$refs.flipCard, this.get_ratio(window))
          }, 1500)
        })
      },
      scrollBarInit () {
        if (window.innerWidth > 1200 && window.innerHeight > 600 && !this.psOne) {
          const containerOne = this.$refs.scrollHookOne
          this.psOne = new PerfectScrollbar(containerOne);
        } else if (this.psOne) {
          this.psOne.destroy()
          this.psOne = null
        }
        window.addEventListener('resize', this.scrollBarInit)
      },
      activeCallback () {
        let int = 800
        let delay = 250 * this.ind
        if(this.active) {
          setTimeout(() => {
            this.ratioInit()
            this.scrollBarInit()
            this.contentActiveClass = ''  
          }, (int + delay))
        } else {
          setTimeout(() => {
            this.contentActiveClass = 'content-inactive'  
          }, (int + delay))     
        }
      }
    },
    computed: {
      cardSizeClass () {
        if(this.cardSize < 3) {

          return this.ind < 1 ? 'span-4-lg offset-3-lg' : 'span-4-lg offset-2-lg'
        } else if (this.cardSize > 3 ) {
          return 'span-3-lg offset-1-lg'
        } else {
          return 'span-4-lg offset-1-lg'
        }
      }
    },
    mounted () {
      this.activeCallback()
    },
    watch: {
      active () {
        this.activeCallback()
      }
    }
  }
</script>

<style scoped lang="scss">

  @import '../../styles/variables';

  //- col with rollover and 3d rotate -//
  // (see https://davidwalsh.name/css-flip#ieflip)

  // perspective container
  .flip-container {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    perspective: 1200px;
    transform-style: preserve-3d;
  }

  .front {
    position: absolute;
    // box-sizing: border-box;
    display: flex;
    top: 0;
    left: 0;
    transform: rotateY(0deg);
  }

  .back {
    position: absolute;
    // box-sizing: border-box;
    top: 0;
    left: 0;
    overflow: hidden;
    display: flex;
    // width: 100%;
    // height: 100%;
    transform: rotateY(-180deg);
  }

  .front, .flipper, .back {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
  }
  
  /* flip speed goes here */
  .flipper {
    position: relative;
    cursor: pointer;
    opacity: 0.75;
    transition: 0.75s;
    transform-style: preserve-3d;
    .crosshair-container {
      opacity: 0;
    }
  }

  /* hide back of pane during swap */
  .front, .back {
    box-sizing: border-box;
    border: 1px solid transparent;
    // background-color: $white-solid;
    background: $blue;
    backface-visibility: hidden;
    transition: 0.75s;
    transform-style: preserve-3d;
    &:hover, &.flipped {
      background: white;
      .front-inner, .back-inner {
        .subheader {
          color: $blue;
        }
      }
    }
  }

  .back.flipped {
    transform: rotateY(0deg);
    // max-height: 100%;
  }

  .front.flipped {
    transform: rotateY(180deg);
  }

  // inner content

  .front-inner, .back-inner {
    position: relative;
    // margin: auto; // disabled for IE
    box-sizing: border-box;
  }

  .front-inner {
    padding: 24px;
    text-align: center;
  }

  .back-inner {
    padding: 24px;
  }

  .front-inner, .back-inner {
    .subheader {
      color: $white;
      transition: all $transition-1;
    }
  }

  .svg-icon-background {
    position: relative;
    margin-bottom: 24px;
  }

  .svg-icon-background-small {
    display: inline-block;
    margin-right: 6px;
    transform: translateY(4px);
  }

  .md-margin-top {
    @media screen and (max-width: $md-max) , screen and (max-height: $md-height-max) {
      margin-top: 24px;
    }
  }

</style>

<style lang="scss">
  @import '../../styles/variables';

  .svg-icon-background-small {
    svg {
      width: 24px;
      height: 24px;
    }
  }

  .front, .back{
    svg {
      g:not(.ignorehover) {
        fill: white;
        transition: all 0.2s ease-in-out;
      }
    }
    &:hover, &.flipped {
      svg {
        g {
          fill: $blue;
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// flip_card.vue?519d2980